import { useQuery } from "@tanstack/react-query";
import { Button, Modal, Space, Spin } from "antd";
import { useState } from "react";
import { BsPlusSquare } from "react-icons/bs";
import { useIntl } from "react-intl";
import { getClosedPeriods, getLocations } from "../../../network/settings";
import { queryKeys } from "../../../services/react-query/queryKeys";
import ModalClosePeriod from "./components/ModalClosePeriod";
import Period from "./components/Period";

type Props = {};

const AboutPeriods = (props: Props) => {
  const [addNewPeriod, setAddNewPeriod] = useState(false);
  const [closeData, setCloseData] = useState<any>(false);
  const showModal = (data: any) => {
    setAddNewPeriod(true);
    setCloseData(data);
  };

  const handleCancel = () => {
    setAddNewPeriod(false);
    setCloseData(false);
  };

  const { data, isLoading } = useQuery([queryKeys?.listClosedPeriods], () =>
    getClosedPeriods()
  );
  const { data: location } = useQuery([queryKeys?.listLocations], () =>
    getLocations()
  );
  console.log(location);
  const intl = useIntl();
  return (
    <>
      <Modal
        width="48%"
        centered
        destroyOnClose={true}
        maskClosable={false}
        open={addNewPeriod}
        className="max-md:min-w-[95%] max-xl:!w-[75%]"
        onCancel={handleCancel}
        footer={false}
      >
        <ModalClosePeriod
          locations={location}
          data={closeData}
          close={handleCancel}
        />
      </Modal>
      <div className="py-8 px-6 bg-[#EEF0FF]">
        <div className="flex items-center justify-between mb-6">
          <h5 className="text-lg font-semibold">
            {intl.formatMessage({ id: "closedPeriodsTitle" })}
          </h5>
          <Button type="primary" onClick={() => showModal(false)}>
            <Space className="flex items-center justify-center text-center">
              <BsPlusSquare className="h-full flex items-center !text-sm" />
              <span className="text-sm font-semibold">
                {intl.formatMessage({ id: "addClosedPeriodButtonLabel" })}
              </span>
            </Space>
          </Button>
        </div>
        <div>
          <div className="flex flex-col items-center w-full gap-4">
            {isLoading ? (
              <Spin></Spin>
            ) : (
              data?.data?.map((e: any) => (
                <Period data={e} showModal={showModal} />
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPeriods;
